// extracted by mini-css-extract-plugin
export var actions = "_lp-g";
export var benefitCard = "_lp-b";
export var benefitIcon = "_lp-d";
export var benefitLabel = "_lp-f";
export var benefits = "_lp-a";
export var benefitsSection = "_lp-8";
export var bodyText = "_lp-7";
export var closeButton = "_lp-2";
export var content = "_lp-3";
export var eyebrow = "_lp-4";
export var heading = "_lp-5";
export var image = "_lp-i";
export var imagePanel = "_lp-h";
export var modal = "_lp-0";
export var offerCard = "_lp-c";
export var offerIcon = "_lp-e";
export var sectionLabel = "_lp-9";
export var shell = "_lp-1";
export var title = "_lp-6";